export default __webpack_public_path__ + "static/media/scrabble-1440w.be918ced.webp";